module.exports = __webpack_public_path__ + "img/874a5a4.jpg";